import React from 'react';
import { Table } from '@tanstack/react-table';

import DataTable from '@/components/DataTable';
import DataTablePagination from '@/components/DataTable/DataTablePagination';
import DataTableViewOptions from '@/components/DataTable/DataTableViewOptions';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import Dialog from '@/components/template/Dialog';

import CreateDocumentCategory from '../../components/create-document-category';
import { IDocumentCategory } from './columns';

interface IProps {
  table: Table<IDocumentCategory>;
  isLoading: boolean;

  canCreate: boolean;
}

const DocumentsCategoriesView: React.FC<IProps> = ({
  isLoading,
  table,
  canCreate,
}) => (
  <Card>
    <CardHeader>
      <CardTitle>Categorias de Documentos</CardTitle>
    </CardHeader>

    <CardContent className="p-0">
      <div className="space-y-4">
        <div className="flex items-center justify-between space-x-4 px-4">
          <DataTableViewOptions table={table} />
          {canCreate && (
            <Dialog
              title="Nova Categoria de Documento"
              trigger={<Button size="sm">Nova categoria</Button>}
            >
              <CreateDocumentCategory />
            </Dialog>
          )}
        </div>
        <DataTable table={table} isLoading={isLoading} />
        <DataTablePagination className="px-4 pb-4" table={table} />
      </div>
    </CardContent>
  </Card>
);

export default DocumentsCategoriesView;
